<div class="stepper-container-ds">
  @if (this.stepperService.hasNextStep()) {
    <div class="track-step-container">
      <ds-stepper appNonFocusableSteps [steps]="stepperSteps" [currentStep]="stepperService.indexCurrentStep"></ds-stepper>
    </div>
  }
  @if (isSectionVisible()) {
    @if (appointmentStepperService.isUserSelected()) {
      <div class="header-container">
        <p>{{ 'steps.booking_consultation' | translate }}</p>
        <strong>{{
          appointmentStepperService.getSpecialistData()?.value.specialistType.description
            ? appointmentStepperService.getSpecialistData()?.value.specialistType.description
            : type?.toLowerCase()
        }}</strong>
        <p>{{ 'steps.for' | translate }}</p>
        <p class="name">{{ appointmentStepperService.getMainUser()?.['fullName'] }}{{ 'steps.dots' | translate }}</p>
      </div>
    }
  }
  @if (this.stepperService.currentStep === 'intro') {
    <app-symptom-assessment-intro></app-symptom-assessment-intro>
  }
  @if (this.stepperService.currentStep === 'days-picker') {
    <app-symptom-assessment-day-picker (daysEmitter)="setDaysAssessment($event)"></app-symptom-assessment-day-picker>
  }
  @if (this.stepperService.currentStep === 'body-parts') {
    <app-symptom-assessment-bodymap (emitZoneSelected)="zoneSelected($event)" (nextStepTriggered)="handleNextStep()"></app-symptom-assessment-bodymap>
  }
  @if (this.stepperService.currentStep === 'symptoms') {
    <app-symptom-assessment-symptoms (emitSymptom)="setSymptom($event)"></app-symptom-assessment-symptoms>
  }
  @if (this.stepperService.currentStep === 'survey') {
    <app-symptom-assessment-survey [symptomSelected]="sympthomSelected" [questions]="systemExpert?.questions" (emitAnswers)="handleAnswers($event)"></app-symptom-assessment-survey>
  }
  @if (this.stepperService.currentStep === 'recap-care-manager') {
    <app-recap-care-manager></app-recap-care-manager>
  }
  @if (this.stepperService.currentStep === 'mode-selection') {
    <app-profile-selection
      [modeSelection]="stepperService.currentStep === 'mode-selection' ? true : false"
      [typeAppointment]="type ? type : ''"
      [profiles]="appointmentStepperService.getUsers()"
      (profileEmitter)="appointmentStepperService.setMainUser($event)"
      (profileInputEmitter)="profileInputData($event)"
      (vetEmitter)="appointmentStepperService.setAppointmentType($event)"
      [vet]="steps?.[stepperService.indexCurrentStep]?.isVideoView ? steps?.[stepperService.indexCurrentStep]?.isVideoView : false"
    ></app-profile-selection>
  }
  @if (this.stepperService.currentStep === 'profile-selection') {
    <app-profile-selection
      [typeAppointment]="type ? type : ''"
      [profiles]="appointmentStepperService.getUsers()"
      (profileEmitter)="setActiveUser($event)"
      (profileInputEmitter)="profileInputData($event)"
      (vetEmitter)="appointmentStepperService.setAppointmentType($event)"
      [vet]="steps?.[stepperService.indexCurrentStep]?.isVideoView ? steps?.[stepperService.indexCurrentStep]?.isVideoView : false"
    ></app-profile-selection>
  }
  @if (this.stepperService.currentStep === 'profile-selection-care-manager') {
    <app-profile-selection-care-manager
      [typeAppointment]="type ? type : ''"
      [profiles]="appointmentStepperService.getUsers()"
      (emitNewProfile)="handleNewProfile()"
      (profileEmitter)="appointmentStepperService.setMainUser($event)"
    ></app-profile-selection-care-manager>
  }
  @if (this.stepperService.currentStep === 'profile-selection-input') {
    <app-profile-selection-input [typeAppointment]="type ? type : ''" (profileSelectionInputEmitter)="profileInputData($event)"></app-profile-selection-input>
  }
  @if (this.stepperService.currentStep === 'specialist-selection') {
    <app-specialist-selection (specialistEmitter)="appointmentStepperService.setSpecialistData($event)"></app-specialist-selection>
  }
  @if (this.stepperService.currentStep === 'specialist-categorization-selection') {
    <app-specialist-categorization-selection (specialistEmitter)="appointmentStepperService.setSpecialistData($event)"></app-specialist-categorization-selection>
  }
  @if (this.stepperService.currentStep === 'request-selection') {
    <app-request-selection
      [hasDocuments]="hasDocuments"
      [hasTravel]="hasTravel"
      (requestSelectionEmitter)="setRequestSelectionData($event)"
      (emitAssistanceForm)="setTravelData($event)"
    ></app-request-selection>
  }
  @if (this.stepperService.currentStep === 'date-selection') {
    <app-date-selection
      [dates]="dates"
      [oldDates]="oldDates"
      [selectedAppointments]="appointmentStepperService.getDateSelectionData()"
      [minAppointments]="minAppointments"
      [maxAppointments]="maxAppointments"
      (dateSelectionEmitter)="appointmentStepperService.setDateSelectionData($event)"
    ></app-date-selection>
  }
  @if (this.stepperService.currentStep === 'one-radio-alimentation') {
    <app-one-radio-info [survey]="surveys" (oneRadioInfoEmitter)="setSurveyAnswers($event)"></app-one-radio-info>
  }
  @if (this.stepperService.currentStep === 'summary-valutation') {
    <app-summary [diagnosis]="diagnosis"></app-summary>
  }
  @if (this.stepperService.currentStep === 'summary') {
    <app-summary-consultation (emitBody)="this.setBody($event)" [survey]="surveys" [type]="type"></app-summary-consultation>
  }
  @if (this.stepperService.currentStep === 'ty-page') {
    <app-ty-page [selectedRoute]="currentRoute"></app-ty-page>
  }
  @if (steps && steps[stepperService.indexCurrentStep].hasTipside) {
    <div class="tipside">
      <app-tipside></app-tipside>
    </div>
  }
  @if (stepperService.currentStep !== 'summary-valutation' && stepperService.currentStep !== 'body-parts' && stepperService.currentStep !== 'ty-page') {
    <div [ngClass]="stepperService.currentStep === 'summary' && payment && onMobile ? 'button-container-mobile-payment' : 'button-container'">
      @if (consultType !== 'SymptomsAssessments' || (stepperService.currentStep === 'date-selection' && modify)) {
        <ds-button class="back-button" text="{{ 'buttons.back' | translate }}" [styleType]="'empty-main'" [width]="'small'" (click)="handlePreviousStep()"></ds-button>
      }

      <!-- Bottone per aggiornare survey -->
      @if (showUpdateButton) {
        <ds-button class="update-btn back-button" text="{{ 'buttons.next' | translate }}" [width]="'small'" (click)="handleSurveyUpdate()"></ds-button>
      }

      <!-- Bottone per avanzare di step -->
      @if (showNextButton) {
        <ds-button class="nextStepbtn" [text]="setButtonText()" [width]="'small'" [isDisabled]="isDisabled(stepperService.currentStep)" (click)="handleNextStep()"></ds-button>
      }
    </div>
  }
</div>
